// extracted by mini-css-extract-plugin
module.exports = {"packageDetail":"packageDetail_1vhfKn0l","packageBaseInfo":"packageBaseInfo_2Di9n1Vd","whiteSpace":"whiteSpace_NDQnRQJL","packageIntro":"packageIntro_3ZCuzc9z","btn":"btn_2eGC9vJ_"};